export const Config = {
  environment: import.meta.env.MODE,
  apiUrl: import.meta.env.VITE_API_BASE_URL,
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    organizationName: import.meta.env.VITE_SENTRY_ORGANIZATION_NAME,
    projectName: import.meta.env.VITE_SENTRY_PROJECT_NAME,
  },
};
